(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper !== "undefined") {
      new Swiper(".banner-swiper", {
        loop: true,
         autoHeight: true,
          effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-orders"]) return;
  try {
      
  
 jQuery(document).ready(function($) {
    // Use a slight delay to ensure the DOM is fully loaded
    setTimeout(function() {
      $('label[for="56205-datetime-1"]').parent().hide();
      $('label[for="56205-datetime-2"]').parent().hide();
        // Change the input type to "date"
        $("#56205-text-6").attr("type", "date");

        // Set the minimum date to today
        let today = new Date().toISOString().split("T")[0];
        $("#56205-text-6").attr("min", today);
    }, 50); // Delay by 50 milliseconds
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-order"]) return;
  try {
    
  jQuery(document).ready(function($) {
    // Use a slight delay to ensure the DOM is fully loaded
    setTimeout(function() {
      $('label[for="58212-datetime-2"]').parent().hide();
      $('label[for="58212-datetime-1"]').parent().hide();
        // Change the input type to "date"
        $("#58212-text-3").attr("type", "date");

        // Set the minimum date to today
        let today = new Date().toISOString().split("T")[0];
        $("#58212-text-3").attr("min", today);
    }, 50); // Delay by 50 milliseconds
});

  } catch(e) { console.error(e); }
})();
})();
